import { useEffect, useState } from 'react';

// UI components & helpers
import Brand from '../components/splash/Brand';
import HelpFooter from '../components/HelpFooter';
import { to_euro } from '../utils/utils';

// hooks
import useFeed from '../hooks/useFeed';
import useProducts from '../hooks/useProducts';
import useSettings from '../hooks/useSettings';
import Ingot from '../components/Ingot';

export default function Products () {

  // hook data deconstruction.
  const { feed, error:fError } = useFeed();
  const { products, error:pError, loading:pLoad } = useProducts();
  const { settings, error:sError, loading:sLoad } = useSettings();

  // local states.
  const [ masterKind, setKind ] = useState( 'XAU' );
  const [ error, set_error ] = useState( null );

  const ingotTabs = () => {
    switch ( masterKind ) {

      default:
      case 'XAU':
        return ( generate_ingot_tabs( 'XAU' ) );

      case 'XAUPAC':
        return ( generate_ingot_tabs( 'XAUPAC' ) );

      case 'XAG':
        return ( generate_ingot_tabs( 'XAG' ) );

      case 'XAGPAC':
        return ( generate_ingot_tabs( 'XAGPAC' ) );
    }
  }

  const priceTag = () => {
    switch ( masterKind ) {

      default:
      case 'XAU':
      case 'XAUPAC':
        return ( <>
          <div className=' price gold '>
            Oro fix: <span className='silver'>{ to_euro( feed.XAU ) }</span> </div>
          <div className=' price gold '>
            aggiornato: <span className='silver'>{ feed.XAU_updated }</span> </div>
        </> );

      case 'XAG':
      case 'XAGPAC':
        return ( <>
          <div className=' price gold '>
            Argento fix: <span className='silver'>{to_euro( feed.XAG )}</span> </div>
          <div className=' price gold '>
            aggiornato: <span className='silver'>{ feed.XAG_updated }</span> </div>
        </> );
    }
  }

  // handle feed errors.
  useEffect(() => {
    if ( fError.type || pError.type || sError.type ) {
      console.log( 'feed error', fError );
      console.log( 'products error', pError );
      console.log( 'settings error', sError );
      set_error( 'feed error', fError, pError, sError );
    }
  }, [ feed, fError, pError, sError ] );



  return (
    <div className='full with-help-footer'>
      <Brand
        variant = "lg"
        align = "left"
        showChevron = 'true' />

      { !error &&
        <div className='cbody--'>

          {/* DIRECT FEEDS */}
          <div className='button-row'>
            { priceTag() }
          </div>

          {/* KIND SWITCH */}
          <div className='button-group'>

            <button
              className = ' button gold-bg'
              onClick   = { () => setKind( 'XAU' ) } >
              Lingotti Oro </button>

            <button
              className = ' button gold-bg'
              onClick   = { () => setKind( 'XAUPAC' ) } >
              Pac Oro </button>

            <button
              className = ' button silver-bg'
              onClick   = { () => setKind( 'XAG' ) } >
              Lingotti Argento </button>

            <button
              className = ' button silver-bg'
              onClick   = { () => setKind( 'XAGPAC' ) } >
              Pac Argento </button>

          </div>

          <div className='divider'></div>

          {/* THE PRODUCTS */}
          <div className='tabs-- '>
            { ingotTabs() }
          </div>


        </div>
      }

      { error && <p>{ error }</p> }

        <HelpFooter
          href="mailto:support@gekogold.com"
          target="_self" />
    </div>
  )


  // FUNCTIONS 2026 :: WIP :::::

  function generate_ingot_tabs( kind )
  {
    let tabs = [];

    products.forEach(( p, i ) => {
      if ( p.kind === kind && p.modifiers.enabled === true ) {
        tabs.push(
          < Ingot
            key   = { p.kind + i }
            data  = { p }
            feed  = { feed }
            masterKind = { masterKind }
            confine = { false }
          />
        );
      }
    });

    switch( kind ) {
      default:
        return tabs;

      case 'XAU':
      case 'XAG':
        return tabs.reverse();
    }

  }

}
